import './styles.scss'
import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './styles.scss'
import { getCampaigns, campaignsUpdateFilters } from 'redux/actions/marketing'
import { MARKETING } from '../../../../constants'
import SearchResult from 'components/SearchResult'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'

const Listing = (props) => {
  const {
    marketing, //, colsToShow },
  } = props

  const dispatch = useDispatch()

  const [sortType, setSortType] = useState(marketing.sortType)
  const [sortByField, setSortByField] = useState(marketing.sortByField)
  const [colsToShow, setColsToShow] = useState([...MARKETING.colsToShowInit])
  const [campaigns, setcampaigns] = useState([])

  useEffect(() => {
    dispatch(getCampaigns())
  }, [dispatch])

  useEffect(() => {
    const newCampaigns = marketing.campaigns.map(value => ({
      ...value,
      state: I18n.t(MARKETING.status[value.state] || value.state || ''),
      startDate: setDate(value.startDate, true),
      endDate: setDate(value.endDate, true),
      createdAt: setDate(value.createdAt),
      durationTime: `${value.duration} ${I18n.t(value.durationLabel || '')}`,
      channelsInFilters: translateChannels(value.channelsInFilters)
    }))
    setcampaigns(newCampaigns)
  }, [marketing.campaigns])

  useEffect(() => {
    setColsToShow([...marketing.colsToShow])
  }, [marketing.colsToShow])

  useEffect(() => {
    if (sortType !== marketing.sortType || sortByField !== marketing.sortByField) {
      setSortByField(marketing.sortByField)
      setSortType(marketing.sortType)
      dispatch(campaignsUpdateFilters('sortByField', marketing.sortByField, false))
      dispatch(campaignsUpdateFilters('sortType', marketing.sortType, false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketing.sortByField, marketing.sortType])

  const setDate = (dateString, dateTime=false)=>{
    const date = moment(dateString)
    if (date.isValid()){
      return dateTime ? date.format('YYYY-MM-DD HH:mm'): date.format('YYYY-MM-DD')
    }
    return ''
  }

  const translateChannels = (channelsInFilters) => {
    let channels = []
    if(channelsInFilters){
      channels = channelsInFilters.map(channel => I18n.t(`channels_${channel}`))
    }
    return channels.join(', ')

  }

  const toggleOrder = (field) => {
    let _sortType = 'desc'
    if (marketing.sortByField === field)
      _sortType = sortType === 'desc' ? 'asc' : 'desc'

    setSortByField(field)
    setSortType(_sortType)
    dispatch(campaignsUpdateFilters('sortByField', field, false))
    dispatch(campaignsUpdateFilters('sortType', _sortType))
  }

  const formatFields = () => {
    const newColsShow = []
    marketing.colsToShow.forEach(colType => {
      newColsShow.push({ ...MARKETING.colsShowCampaign.find(col => col.value === colType), isSelected: true })
    })
    MARKETING.colsShowCampaign.forEach(col => {
      if (!newColsShow.find(newCol => newCol.value === col.value)) newColsShow.push({ ...col, isSelected: false })
    })
    return newColsShow
  }

  const onChangeConfigHeader = (newOrder) => dispatch(campaignsUpdateFilters('colsToShow', newOrder))

  const onChangeMassiveActions = (field, value)=>{
    if(field !== 'page')
      dispatch(campaignsUpdateFilters(field, value))
    else
      dispatch(campaignsUpdateFilters('page', field === 'page' ? value : 0))
  }

  const detailResults = campaign => props.history.push(`${props.match.url}/${campaign._id}`)

  const onChangeActionBooking = (check, campaignId, isAll) => {
    let tempCheck = marketing.checked
    if(!isAll){
      if(check) tempCheck.push(campaignId)
      else{
        const index = tempCheck.indexOf(campaignId)
        tempCheck.splice(index, 1)
      }
    }else{
      if(!check) tempCheck = []
      else{
        for(const { _id } of campaigns)
          tempCheck.push(_id)
      }
    }
    dispatch(campaignsUpdateFilters('checked', tempCheck, false))
  }

  return (
    <div className='campaign-right-results'>
      <SearchResult
        colsToShow={colsToShow}
        fieldsColumns={formatFields()}
        onChangeConfigHeader={onChangeConfigHeader}
        results={campaigns}
        toggleOrder={toggleOrder}
        sortType={sortType}
        sortByField={sortByField}
        onChangeMassiveAction={onChangeMassiveActions}
        limit={marketing.limit}
        totalResult={marketing.totalCampaigns}
        numberPage={marketing.page}
        onChangeActionResultCheck={onChangeActionBooking}
        checkResult={marketing.checked}
        detailResult={detailResults}
        originType={'camp'}
      />
    </div>
  )
}

export default connect((state) => ({
  marketing: state.marketing,
  colsToShow: state.marketing.colsToShow,
  user: state.user,
}))(withRouter(Listing))
